import { render, staticRenderFns } from "./TypingMessage.vue?vue&type=template&id=5454cb3c&scoped=true&"
import script from "./TypingMessage.vue?vue&type=script&lang=js&"
export * from "./TypingMessage.vue?vue&type=script&lang=js&"
import style0 from "./TypingMessage.vue?vue&type=style&index=0&id=5454cb3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5454cb3c",
  null
  
)

export default component.exports